module.exports = __webpack_public_path__ + "img/diagramaDemostradorAIDIMME.0f2a24e2.png";